import React from "react";
import { Link } from "react-router-dom";
import "./BrandLogo.css";

const LOGO_SRC = "/assets/visa-appointment-bot-logo-nav.png";
const LOGO_HD_SRC = "/assets/visa-appointment-bot-logo.png";

export default function BrandLogo({
  to = "/",
  className = "",
  height = 40,
  title = "Visa Appointment Bot",
  asLink = true,
}) {
  const image = (
    <img
      src={LOGO_SRC}
      srcSet={`${LOGO_SRC} 1x, ${LOGO_HD_SRC} 2x`}
      alt={title}
      className="brand-logo-img"
      style={{ height }}
      draggable={false}
    />
  );

  if (!asLink) {
    return <span className={`brand-logo ${className}`.trim()}>{image}</span>;
  }

  return (
    <Link to={to} className={`brand-logo ${className}`.trim()} title={title}>
      {image}
    </Link>
  );
}
